import { UserUrl } from "./AUrl";
import axios, {AxiosResponse} from 'axios';
import { ApiResponse } from "../interfaces";


export interface Agreement {
    agreement_id: number;
    agreement_date: Date;
    agreement_type_name: string;
    agreement_type_version: number;
    agreement_type_date: Date;
}

// Use this type when dealing with the API response
export type AgreementResponse = Agreement[];


export async function getAgreements(token: string): Promise<ApiResponse<AgreementResponse>> {
    const url = new UserUrl().agreements;
    let response: AxiosResponse<any>;
    try {
        response = await axios.get<AgreementResponse | string>(url, {
            headers: {
                'Content-Type': 'application/json',
                'token': token
            },
            // Resolve the promise for all HTTP status codes
            validateStatus: () => true
        });
        if (response.status === 200) {
            return {
                status: response.status,
                data: response.data as AgreementResponse
            };
        }
        else {
            return {
                status: response.status,
                error: response.data as string
            };
        }

    } catch (error) {
        return {
            status: 500,
            error: error as string
        };
    }
}
